const sectionStepsTabs = () => {
    document.querySelectorAll('.js-filter-steps-tab').forEach(element => {
        element.addEventListener('click', e => {
            document
                .querySelectorAll('.js-filter-steps-tab')
                .forEach(element => {
                    element.classList.remove('is-active');
                });
            e.target.classList.add('is-active');
            document.querySelectorAll('.js-steps-tab').forEach(tab => {
                tab.classList.add('u-hidden');
            });
            document
                .querySelectorAll(`.js-filter-${element.dataset.filter}`)
                .forEach(filtered => {
                    filtered.classList.remove('u-hidden');
                });
        });
    });
};

export default sectionStepsTabs;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/kerris-select-chisel/src/scripts/modules/section-steps-tabs.js